
import api from '../../../services/api';
const URL = '/todos';

class TodoService {
    getTodos(params = {}) {
        return api.get(URL, { params });
    }

    getTodo(id) {
        return api.get(`${URL}/${id}/`);
    }

    createTodo(data) {
        return api.post(URL, data);
    }

    updateTodo(id, data) {
        return api.put(`${URL}/${id}/`, data);
    }

    deleteTodo(id) {
        return api.delete(`${URL}/${id}/`);
    }

    toggleCompleted(id) {
        return api.patch(`${URL}/${id}/toggle-completed/`);
    }

    toggleStarred(id) {
        return api.patch(`${URL}/${id}/toggle-starred/`);
    }

    reorderTodos(reorderData) {
        return api.post(`${URL}/reorder/`, { reorder_data: reorderData });
    }
}

export default new TodoService()